<template>
  <div class="article">
    <Hero :title="articleMetadata.title" :imageUrl="articleMetadata.image" />
    <div class="content" v-html="articleContent"></div>
  </div>
</template>

<script>
import Hero from '@/components/Hero.vue';
import markdownIt from 'markdown-it';
import markdownItForInline from 'markdown-it-for-inline';

export default {
  name: 'Article',
  components: {
    Hero,
  },
  data() {
    return {
      articleMetadata: {},
      articleContent: '',
    };
  },
  async created() {
    const section = this.$route.params.section;
    const articleId = this.$route.params.id;

    // Import metadata
    try {
      const metaModule = await import(`@/content/${section}/${articleId}/metadata.json`);
      this.articleMetadata = metaModule.default;
    } catch (error) {
      this.$router.push('/');
    }

    // Import markdown content
    try {
      const contentModule = await import(`@/content/${section}/${articleId}/index.md`);
      const mdContent = contentModule.default;

      const md = markdownIt();

      // Use markdown-it-for-inline to process inline elements
      md.use(markdownItForInline, 'image_handler', 'image', (tokens, idx) => {
        const token = tokens[idx];
        const srcIndex = token.attrIndex('src');
        let src = token.attrs[srcIndex][1];

        // Handle '@/' alias in image paths
        if (src.startsWith('@/')) {
          // Replace '@/' with '/src/'
          src = src.replace('@/', '/src/');

          // Use require to resolve the image path
          try {
            const resolvedSrc = require(`${src}`);
            token.attrs[srcIndex][1] = resolvedSrc;
          } catch (e) {
            console.error(`Image not found: ${src}`, e);
            // Optionally, set a placeholder image or handle the error as needed
          }
        }
      });

      // Render the markdown content
      this.articleContent = md.render(mdContent);
    } catch (error) {
      this.$router.push('/');
    }
  },
};
</script>

<style scoped>
/* Add component-specific styles */
</style>